import { Amplify, ResourcesConfig } from "aws-amplify";
export {
  signUp,
  confirmSignUp,
  signIn,
  signOut,
  getCurrentUser,
  fetchAuthSession,
  resetPassword,
  resendSignUpCode,
  confirmResetPassword,
  confirmSignIn,
  signInWithRedirect,
  updatePassword,
} from "aws-amplify/auth";

import "aws-amplify/auth/enable-oauth-listener";

export const cognito = {
  init: (config: ResourcesConfig["Auth"]) => {
    Amplify.configure({
      Auth: config,
    });
  },
};
